import type { FundSource } from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../../styled-system/css";
import bannerSuccess from "../../../assets/hokkaido/banner_success.jpg";
import { t } from "../../../libs/i18n";
import { formatNumber } from "../../../libs/utils";

export type HokkaidoR8HouseholderReceiveDetail = {
  amount: bigint;
  fundSource?: FundSource;
};

export function HokkaidoR8HouseholderOverlay({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div
      className={css({
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(226, 226, 226, 0.5)",
        backdropFilter: "blur(4px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        p: "20px",
      })}
    >
      {children}
    </div>
  );
}

// ハガキのシリアルナンバーとマイナポータル認証のどちらで受け取っても同じ完了画面を出す
export function HokkaidoR8HouseholderReceiveSuccessModal({
  detail,
  onClose,
}: {
  detail: HokkaidoR8HouseholderReceiveDetail;
  onClose: () => void;
}) {
  return (
    <HokkaidoR8HouseholderOverlay>
      <div
        className={css({
          bg: "white",
          rounded: "16px",
          w: "full",
          maxWidth: "360px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        })}
      >
        <img
          src={bannerSuccess}
          alt={t("どうみんポイント")}
          className={css({
            display: "block",
            w: "full",
            roundedTop: "16px",
          })}
        />
        <div
          className={css({
            p: "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
          })}
        >
          <p
            className={css({
              fontSize: "14px",
              color: "text.primary",
              textAlign: "center",
            })}
          >
            {t("{amount}ポイントが付与されました！", {
              amount: formatNumber(Number(detail.amount)),
            })}
          </p>
          <HokkaidoR8HouseholderAmountBlock detail={detail} />
          <button
            type="button"
            onClick={onClose}
            className={css({
              padding: "12px",
              borderRadius: "8px",
              width: "100%",
              fontWeight: "bold",
              cursor: "pointer",
              backgroundColor: "surface.secondary",
              color: "text.primary",
              border: "1px solid",
              borderColor: "border.secondary",
            })}
          >
            {t("閉じる")}
          </button>
        </div>
      </div>
    </HokkaidoR8HouseholderOverlay>
  );
}

export function HokkaidoR8HouseholderAmountBlock({
  detail,
}: {
  detail: HokkaidoR8HouseholderReceiveDetail;
}) {
  return (
    <div
      className={css({
        bg: "surface.accentSuccessLight",
        rounded: "8px",
        p: "16px",
        width: "100%",
        textAlign: "center",
      })}
    >
      {detail.fundSource && (
        <div
          className={css({
            fontSize: "12px",
            color: "text.secondary",
            marginBottom: "4px",
          })}
        >
          {detail.fundSource.name}
        </div>
      )}
      <div
        className={css({
          display: "flex",
          alignItems: "baseline",
          justifyContent: "center",
          gap: "4px",
        })}
      >
        <span
          className={css({
            fontSize: "32px",
            fontWeight: "bold",
            color: "text.accentSuccess",
          })}
        >
          {formatNumber(Number(detail.amount))}
        </span>
        <span
          className={css({
            fontSize: "14px",
            color: "text.accentSuccess",
          })}
        >
          pt
        </span>
      </div>
    </div>
  );
}
